import { FC } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import { projectSelectors } from '../../../store/modules/project';

export type MyProjectsSearchNotFoundProps = {};

const Text = styled.div`
  margin-top: 100px;
  text-align: center;
  font-weight: 700;
  font-size: 30px;
  line-height: 42px;
  color: #292a2b;
`;

const MyProjectsSearchNotFound: FC<MyProjectsSearchNotFoundProps> = () => {
  const isSearchActive = !!useSelector(projectSelectors.selectProjectsSearchKeyWord);
  const isPending = useSelector(projectSelectors.selectSearchProjectsPending);

  const projects = useSelector(projectSelectors.selectSearchProjectsList);
  const isEmpty = projects.length === 0;

  if (!isEmpty || isPending || !isSearchActive) return null;

  return <Text>No results found. Try different keywords</Text>;
};

export default MyProjectsSearchNotFound;
